<template>
  <div>
    <b-table-simple responsive>
      <b-tbody>
        <template v-if="teaching_profiles.length > 0">
          <template v-for="(teaching_profile, index) in teaching_profiles">
            <b-tr :key="'profile_header_' + teaching_profile.id">
              <b-th colspan="10" rowspan="1">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="flex-grow-1 text-center">
                    {{
                      $t(
                        "matterProgram.matterProgramView.teachingProfile"
                      ).toUpperCase()
                    }}
                    {{ index + 1 }}
                  </span>
                  <div>
                    <ButtonSmall
                      v-if="
                        index == 0 &&
                        allows_crud &&
                        oldMatter &&
                        !oldMatter.is_closed &&
                        can_update
                      "
                      :tooltip_text="
                        $t(
                          'matterProgram.matterProgramView.addNewTeachingProfile'
                        )
                      "
                      :click_button="createTeachingProfileBase"
                      :class="`ml-1`"
                      :icon="'plus'"
                      :variant="'none'"
                      :custom_class="'text-white'"
                    >
                    </ButtonSmall>
                    <ButtonSmall
                      v-if="
                        allows_crud &&
                        oldMatter &&
                        !oldMatter.is_closed &&
                        can_update
                      "
                      :tooltip_text="
                        $t(
                          'matterProgram.matterProgramView.editTeachingProfile'
                        )
                      "
                      :click_button="
                        () =>
                          $bvModal.show(
                            `edit-teaching-profile-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                      "
                      :class="`ml-1`"
                      :icon="'square'"
                      :variant="'none'"
                      :custom_class="'text-white'"
                    >
                    </ButtonSmall>
                    <ButtonSmall
                      v-if="
                        allows_crud &&
                        oldMatter &&
                        !oldMatter.is_closed &&
                        can_delete
                      "
                      :click_button="
                        () => deleteTeachingProfile(teaching_profile)
                      "
                      :tooltip_text="
                        $t(
                          'matterProgram.matterProgramView.deleteTeachingProfile'
                        )
                      "
                      :class="`mx-1`"
                      :icon="'trash'"
                      :variant="'danger'"
                      :variant_icon="'light'"
                    ></ButtonSmall>
                  </div>
                </div>
                <div class="d-flex justify-content-center mb-1">
                  <div
                    class="mr-2 kl-chip d-flex"
                    v-if="
                      institution &&
                      teaching_profile &&
                      ((institution.internal_use_id != 'duoc.cl' &&
                        teaching_profile.total_hours > 0) ||
                        (institution.internal_use_id == 'duoc.cl' &&
                          teaching_profile.total_theory_hours > 0))
                    "
                  >
                    <!-- {{
                      $getVisibleNames(
                        "manual.total_pedagogical_hours",
                        true,
                        "Total de Horas Pedagógicas"
                      )
                    }} -->
                    {{
                      institution && institution.internal_use_id != "duoc.cl"
                        ? $getVisibleNames(
                            "manual.total_pedagogical_hours",
                            true,
                            "Total de Horas Pedagógicas"
                          )
                        : $t("matterProgram.matterProgramView.theoryHours")
                    }}
                    <!-- v-if="!allows_crud || (oldMatter && oldMatter.is_closed)" -->
                    <span
                      v-if="
                        institution && institution.internal_use_id != 'duoc.cl'
                      "
                      >:
                      {{
                        teaching_profile.total_hours
                          ? teaching_profile.total_hours
                          : $t("reusable.common.notApplicable")
                      }}
                    </span>
                    <span v-else>
                      :
                      {{
                        teaching_profile.total_theory_hours
                          ? teaching_profile.total_theory_hours
                          : $t("reusable.common.notApplicable")
                      }}
                    </span>
                    <!-- <b-form-input
                      v-else
                      :id="`input-teaching-profile-${teaching_profile.id}`"
                      type="number"
                      min="0"
                      :state="
                        totalPedagogical -
                          maxHoursTeachingProfile(teaching_profile.id) >=
                        teaching_profile.total_hours
                      "
                      @input="patchHourTeachingProfile(teaching_profile)"
                      v-model.number="teaching_profile.total_hours"
                      class="input-number-hour ml-1"
                    ></b-form-input>
                    <b-popover
                      v-if="
                        allows_crud &&
                        totalPedagogical -
                          maxHoursTeachingProfile(teaching_profile.id) <
                          teaching_profile.total_hours
                      "
                      variant="warning"
                      placement="bottom"
                      :target="`input-teaching-profile-${teaching_profile.id}`"
                      show
                    >
                      <template>
                        La suma de las horas de los docentes superó el máximo:
                        {{ totalPedagogical }}
                      </template>
                    </b-popover> -->
                  </div>
                  <div
                    v-if="
                      institution &&
                      institution.internal_use_id == 'duoc.cl' &&
                      teaching_profile.total_practical_hours > 0
                    "
                    class="mr-2 kl-chip d-flex"
                  >
                    {{ $t("matterProgram.matterProgramView.practicalHours") }}
                    <span
                      >:
                      {{
                        teaching_profile.total_practical_hours
                          ? teaching_profile.total_practical_hours
                          : $t("reusable.common.notApplicable")
                      }}
                    </span>
                  </div>
                  <div
                    v-if="
                      institution &&
                      institution.internal_use_id == 'duoc.cl' &&
                      teaching_profile.total_hours_not_attended > 0
                    "
                    class="mr-2 kl-chip d-flex"
                  >
                    {{
                      $t("matterProgram.matterProgramView.nonAttendanceHours")
                    }}
                    <span
                      >:
                      {{
                        teaching_profile.total_hours_not_attended
                          ? teaching_profile.total_hours_not_attended
                          : $t("reusable.common.notApplicable")
                      }}
                    </span>
                  </div>
                  <div
                    v-if="
                      teaching_profile && teaching_profile.experience_years > 0
                    "
                    class="mr-2 kl-chip d-flex"
                    v-b-tooltip.v-secondary.noninteractive.hover.top="
                      $t(
                        'matterProgram.matterProgramView.professionalExperienceYearsTooltip'
                      )
                    "
                  >
                    {{
                      $t(
                        "matterProgram.matterProgramView.professionalExperienceYears"
                      )
                    }}
                    <!-- v-if="!allows_crud || (oldMatter && oldMatter.is_closed)" -->
                    <span
                      >:
                      {{
                        teaching_profile.experience_years
                          ? teaching_profile.experience_years
                          : $t("reusable.common.notApplicable")
                      }}
                    </span>
                    <!-- <b-form-input
                      v-else
                      type="number"
                      min="0"
                      v-model.number="teaching_profile.experience_years"
                      @input="
                        (value) => {
                          if (value >= 0 && teaching_profile.total_hours >= 0)
                            patchTeachingProfile(teaching_profile);
                          else if (value < 0)
                            teaching_profile.experience_years = 0;
                        }
                      "
                      class="input-number-year ml-1"
                    ></b-form-input> -->
                  </div>
                </div>
              </b-th>
            </b-tr>
            <b-tr
              v-if="
                allows_crud ||
                hasRichContent(teaching_profile.professional_title)
              "
              :key="'professional_title_' + teaching_profile.id"
            >
              <b-td colspan="1" style="width: 25%">
                <strong>
                  {{
                    $getVisibleNames(
                      "manual.titulo_profesional",
                      false,
                      "Título Profesional"
                    )
                  }}:</strong
                >
              </b-td>
              <b-td colspan="9">
                <div class="d-flex">
                  <RenderVHtml
                    class="w-100"
                    :content="teaching_profile.professional_title"
                  ></RenderVHtml>
                  <!-- <template
                    v-if="allows_crud && oldMatter && !oldMatter.is_closed"
                  >
                    <div class="d-flex align-content-center p-1">
                      <ButtonSmall
                        tabindex="-1"
                        :tooltip_text="`Editar`"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `edit-professional_title-modal-${teaching_profile.id}-${matter_form_view}`
                            )
                        "
                        :class="``"
                        :icon="'square'"
                      ></ButtonSmall>
                      <ButtonSmall
                        v-if="teaching_profile.professional_title"
                        tabindex="-1"
                        :tooltip_text="`Limpiar`"
                        :click_button="
                          () => clearProfessionalTitle(teaching_profile)
                        "
                        :class="`ml-1`"
                        :icon="'clean'"
                      ></ButtonSmall>
                    </div>
                    <b-modal
                      :id="`edit-professional_title-modal-${teaching_profile.id}-${matter_form_view}`"
                      :title="`Editar ${$getVisibleNames(
                        'manual.titulo_profesional',
                        false,
                        'Título Profesional'
                      )}`"
                      size="lg"
                      hide-footer
                      ignore-enforce-focus-selector="#sidebar-right"
                    >
                      <NewRichTextEditor
                        :Object="teaching_profile"
                        :Text="teaching_profile.professional_title"
                        @save="updateProfessionalTitle"
                        :permit_blank="true"
                        @close="
                          $bvModal.hide(
                            `edit-professional_title-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                        "
                      ></NewRichTextEditor>
                    </b-modal>
                  </template> -->
                </div>
              </b-td>
            </b-tr>
            <b-tr
              v-if="
                allows_crud || hasRichContent(teaching_profile.academic_degree)
              "
              :key="'academic_degree_' + teaching_profile.id"
            >
              <b-td colspan="1" style="width: 25%">
                <strong>
                  {{
                    $getVisibleNames(
                      "manual.grado_academico",
                      false,
                      "Grado Académico"
                    )
                  }}:</strong
                >
              </b-td>
              <b-td colspan="9">
                <div class="d-flex">
                  <RenderVHtml
                    class="w-100"
                    :content="teaching_profile.academic_degree"
                  ></RenderVHtml>
                  <!-- <template
                    v-if="allows_crud && oldMatter && !oldMatter.is_closed"
                  >
                    <div class="d-flex align-content-center p-1">
                      <ButtonSmall
                        tabindex="-1"
                        :tooltip_text="`Editar`"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `edit-academic_degree-modal-${teaching_profile.id}-${matter_form_view}`
                            )
                        "
                        :class="``"
                        :icon="'square'"
                      ></ButtonSmall>

                      <ButtonSmall
                        v-if="teaching_profile.academic_degree"
                        tabindex="-1"
                        :tooltip_text="`Limpiar`"
                        :click_button="
                          () => clearAcademicDegree(teaching_profile)
                        "
                        :class="`ml-1`"
                        :icon="'clean'"
                      ></ButtonSmall>
                    </div>
                    <b-modal
                      :id="`edit-academic_degree-modal-${teaching_profile.id}-${matter_form_view}`"
                      :title="`Editar ${$getVisibleNames(
                        'manual.grado_academico',
                        false,
                        'Grado Académico'
                      )}`"
                      size="lg"
                      hide-footer
                      ignore-enforce-focus-selector="#sidebar-right"
                    >
                      <NewRichTextEditor
                        :Object="teaching_profile"
                        :Text="teaching_profile.academic_degree"
                        :permit_blank="true"
                        @save="updateAcademicDegree"
                        @close="
                          $bvModal.hide(
                            `edit-academic_degree-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                        "
                      ></NewRichTextEditor>
                    </b-modal>
                  </template> -->
                </div>
              </b-td>
            </b-tr>
            <b-tr
              v-if="
                allows_crud || hasRichContent(teaching_profile.specialization)
              "
              :key="'specialization_' + teaching_profile.id"
            >
              <b-td colspan="1" style="width: 25%">
                <strong>
                  {{
                    $getVisibleNames(
                      "manual.especializacion",
                      false,
                      "Especialización"
                    )
                  }}:</strong
                >
              </b-td>
              <b-td colspan="9">
                <div class="d-flex">
                  <RenderVHtml
                    class="w-100"
                    :content="teaching_profile.specialization"
                  ></RenderVHtml>
                  <!-- <template
                    v-if="allows_crud && oldMatter && !oldMatter.is_closed"
                  >
                    <div class="d-flex align-content-center p-1">
                      <ButtonSmall
                        tabindex="-1"
                        :tooltip_text="`Editar`"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `edit-specialization-modal-${teaching_profile.id}-${matter_form_view}`
                            )
                        "
                        :class="``"
                        :icon="'square'"
                      ></ButtonSmall>

                      <ButtonSmall
                        v-if="teaching_profile.specialization"
                        tabindex="-1"
                        :tooltip_text="`Limpiar`"
                        :click_button="
                          () => clearSpecialization(teaching_profile)
                        "
                        :class="`ml-1`"
                        :icon="'clean'"
                      ></ButtonSmall>
                    </div>
                    <b-modal
                      :id="`edit-specialization-modal-${teaching_profile.id}-${matter_form_view}`"
                      :title="`Editar ${$getVisibleNames(
                        'manual.especializacion',
                        false,
                        'Especialización'
                      )}`"
                      size="lg"
                      hide-footer
                      ignore-enforce-focus-selector="#sidebar-right"
                    >
                      <NewRichTextEditor
                        :Object="teaching_profile"
                        :Text="teaching_profile.specialization"
                        @save="updateSpecialization"
                        :permit_blank="true"
                        @close="
                          $bvModal.hide(
                            `edit-specialization-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                        "
                      ></NewRichTextEditor>
                    </b-modal>
                  </template> -->
                </div>
              </b-td>
            </b-tr>
            <b-tr
              v-if="
                allows_crud || hasRichContent(teaching_profile.required_skills)
              "
              :key="'required_skills_' + teaching_profile.id"
            >
              <b-td colspan="1" style="width: 25%">
                <strong>
                  {{
                    $getVisibleNames(
                      "manual.habilidades_requeridas",
                      true,
                      "Habilidades Requeridas"
                    )
                  }}:</strong
                >
              </b-td>
              <b-td colspan="9">
                <div class="d-flex">
                  <RenderVHtml
                    class="w-100"
                    :content="teaching_profile.required_skills"
                  ></RenderVHtml>
                  <!-- <template
                    v-if="allows_crud && oldMatter && !oldMatter.is_closed"
                  >
                    <div class="d-flex align-content-center p-1">
                      <ButtonSmall
                        tabindex="-1"
                        :tooltip_text="`Editar`"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `edit-required_skills-modal-${teaching_profile.id}-${matter_form_view}`
                            )
                        "
                        :class="``"
                        :icon="'square'"
                      ></ButtonSmall>

                      <ButtonSmall
                        v-if="teaching_profile.required_skills"
                        tabindex="-1"
                        :tooltip_text="`Limpiar`"
                        :click_button="
                          () => clearRequiredSkills(teaching_profile)
                        "
                        :class="`ml-1`"
                        :icon="'clean'"
                      ></ButtonSmall>
                    </div>
                    <b-modal
                      :id="`edit-required_skills-modal-${teaching_profile.id}-${matter_form_view}`"
                      :title="`Editar ${$getVisibleNames(
                        'manual.habilidades_requeridas',
                        true,
                        'Habilidades Requeridas'
                      )}`"
                      size="lg"
                      hide-footer
                      ignore-enforce-focus-selector="#sidebar-right"
                    >
                      <NewRichTextEditor
                        :Object="teaching_profile"
                        :Text="teaching_profile.required_skills"
                        @save="updateRequiredSkills"
                        :permit_blank="true"
                        @close="
                          $bvModal.hide(
                            `edit-required_skills-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                        "
                      ></NewRichTextEditor>
                    </b-modal>
                  </template> -->
                </div>
              </b-td>
            </b-tr>
            <b-tr
              v-if="
                allows_crud ||
                hasRichContent(teaching_profile.work_experience_validity)
              "
              :key="'work_experience_validity' + teaching_profile.id"
            >
              <b-td colspan="1" style="width: 25%">
                <strong>
                  {{
                    $getVisibleNames(
                      "manual.vigencia_experiencia_laboral",
                      false,
                      "Vigencia Experiencia Laboral"
                    )
                  }}:</strong
                >
              </b-td>
              <b-td colspan="9">
                <div class="d-flex">
                  <RenderVHtml
                    class="w-100"
                    :content="teaching_profile.work_experience_validity"
                  ></RenderVHtml>
                  <!-- <template
                    v-if="allows_crud && oldMatter && !oldMatter.is_closed"
                  >
                    <div class="d-flex align-content-center p-1">
                      <ButtonSmall
                        tabindex="-1"
                        :tooltip_text="`Editar`"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `edit-work_experience_validity-modal-${teaching_profile.id}-${matter_form_view}`
                            )
                        "
                        :class="``"
                        :icon="'square'"
                      ></ButtonSmall>

                      <ButtonSmall
                        v-if="teaching_profile.work_experience_validity"
                        tabindex="-1"
                        :tooltip_text="`Limpiar`"
                        :click_button="
                          () => clearWorkExperienceValidity(teaching_profile)
                        "
                        :class="`ml-1`"
                        :icon="'clean'"
                      ></ButtonSmall>
                    </div>
                    <b-modal
                      :id="`edit-work_experience_validity-modal-${teaching_profile.id}-${matter_form_view}`"
                      :title="`${$getVisibleNames(
                        'manual.vigencia_experiencia_laboral',
                        false,
                        'Vigencia Experiencia Laboral'
                      )}`"
                      size="lg"
                      hide-footer
                      ignore-enforce-focus-selector="#sidebar-right"
                    >
                      <NewRichTextEditor
                        :Object="teaching_profile"
                        :Text="teaching_profile.work_experience_validity"
                        @save="updateWorkExperienceValidity"
                        :permit_blank="true"
                        @close="
                          $bvModal.hide(
                            `edit-work_experience_validity-modal-${teaching_profile.id}-${matter_form_view}`
                          )
                        "
                      ></NewRichTextEditor>
                    </b-modal>
                  </template> -->
                </div>
              </b-td>
              <b-modal
                :id="`edit-teaching-profile-modal-${teaching_profile.id}-${matter_form_view}`"
                :title="
                  $t('matterProgram.matterProgramView.editTeachingProfile')
                "
                size="lg"
                hide-footer
              >
                <TeachingProfileForm
                  v-if="oldMatter"
                  :TeachingProfile="teaching_profile"
                  @updated="slotUpdatedTeachingProfile"
                  :oldMatter="oldMatter"
                  :teaching_profiles="teaching_profiles"
                  :matter="matter"
                ></TeachingProfileForm>
              </b-modal>
            </b-tr>
          </template>
        </template>
        <template v-else-if="allows_crud">
          <template>
            <b-tr>
              <b-th colspan="10" rowspan="1">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="flex-grow-1 text-center">
                    {{
                      $t(
                        "matterProgram.matterProgramView.teachingProfile"
                      ).toUpperCase()
                    }}
                  </span>
                  <div>
                    <ButtonSmall
                      v-if="
                        allows_crud &&
                        oldMatter &&
                        !oldMatter.is_closed &&
                        can_update
                      "
                      :tooltip_text="
                        $t(
                          'matterProgram.matterProgramView.addNewTeachingProfile'
                        )
                      "
                      :click_button="createTeachingProfileBase"
                      :class="`mr-1`"
                      :icon="'plus'"
                      :variant="'none'"
                      :custom_class="'text-white'"
                    >
                    </ButtonSmall>
                  </div>
                </div>
              </b-th>
            </b-tr>
          </template>
        </template>
      </b-tbody>
    </b-table-simple>
    <b-modal
      :id="`create-teaching-profile-modal-${matter_form_view}`"
      :title="$t('matterProgram.matterProgramView.createTeachingProfile')"
      size="lg"
      hide-footer
    >
      <TeachingProfileForm
        @created="slotCreatedTeachingProfile"
        :oldMatter="oldMatter"
        :teaching_profiles="teaching_profiles"
        :matter="matter"
      ></TeachingProfileForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast, htmlToPlainText } from "@/utils/utils";

export default {
  name: "TeachingProfileComponent",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    // ContainerRichTextKlv3: () =>
    //   import("@/components/reusable/ContainerRichTextKlv3"),
    TeachingProfileForm: () =>
      import(
        "@/components/teaching/MatterProgram/Components/TeachingProfileForm"
      ),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    oldMatter: {
      type: Object,
      required: true,
    },
    matter_form_view: {
      type: Boolean,
      default: false,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    matter: {
      type: [Object, null],
    },
  },
  data() {
    return {
      fetch_finish: false,
      teaching_profiles: [],
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      time_allocations: names.TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
    }),
    matterHours() {
      let list = [];
      this.time_allocations.forEach((element) => {
        if (this.matter && !this.matter.use_matter_values) {
          const matter_hour = this.ep_matter_time_allocations.find(
            (x) =>
              x.egress_profile_matter == this.matter.id &&
              x.time_allocation == element.id
          );
          if (matter_hour)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              egress_profile_matter: matter_hour.egress_profile_matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.matter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.matter.weeks)
                    )
                  : 0,
            });
        } else {
          const matter_hour = this.matter_time_allocations.find(
            (x) =>
              x.matter == this.oldMatter.id && x.time_allocation == element.id
          );
          if (matter_hour && this.oldMatter)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              matter: matter_hour.matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.oldMatter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.oldMatter.weeks)
                    )
                  : 0,
            });
        }
      });
      return list;
    },
    totalPedagogical() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == true)
        .forEach((element) => {
          if (
            element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
  },
  methods: {
    hasRichContent(html) {
      if (!html) return false;
      return htmlToPlainText(html).trim().length > 0;
    },
    slotUpdatedTeachingProfile(teaching_profile) {
      this.updateTeachingProfile(teaching_profile);
      this.$bvModal.hide(
        `edit-teaching-profile-modal-${teaching_profile.id}-${this.matter_form_view}`
      );
    },
    slotCreatedTeachingProfile(teaching_profile) {
      this.createTeachingProfile(teaching_profile);
      this.$bvModal.hide(
        `create-teaching-profile-modal-${this.matter_form_view}`
      );
    },
    fetchTeachingProfile() {
      if (this.oldMatter) {
        this.$restful
          .GetAll(`/teaching/teaching-profile/?matter=${this.oldMatter.id}`)
          .then((response) => {
            this.teaching_profiles = response;
            this.fetch_finish = true;
            // if (response.length == 0 && this.allows_crud)
            //   this.createTeachingProfileBase();
          });
      }
    },
    createTeachingProfileBase() {
      this.$bvModal.show(
        `create-teaching-profile-modal-${this.matter_form_view}`
      );
      // this.createTeachingProfile({
      //   professional_title: "",
      //   academic_degree: "",
      //   specialization: "",
      //   required_skills: "",
      //   total_hours: 0,
      //   experience_years: 0,
      //   work_experience_validity: "",
      // });
    },
    deleteTeachingProfile(teaching_profile) {
      this.$swal({
        title: this.$t(
          "matterProgram.matterProgramView.deleteTeachingProfileConfirm"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(`/teaching/teaching-profile/${teaching_profile.id}/`)
            .then(() => {
              const index = this.teaching_profiles.findIndex(
                (x) => x.id == teaching_profile.id
              );
              if (index != -1) {
                this.$emit("change_teaching_profile");
                this.teaching_profiles.splice(index, 1);
                toast(
                  this.$t(
                    "matterProgram.matterProgramView.teachingProfileDeleted"
                  )
                );
              }
            });
        }
      });
    },
    maxHoursTeachingProfile(teaching_profile_id) {
      return this.teaching_profiles
        .filter((x) => x.id != teaching_profile_id)
        .map((x) => x.total_hours)
        .reduce((a, b) => a + b, 0);
    },
    // patchHourTeachingProfile(teaching_profile) {
    //   if (
    //     teaching_profile.total_hours >= 0 &&
    //     teaching_profile.experience_years >= 0 &&
    //     this.totalPedagogical -
    //       this.maxHoursTeachingProfile(teaching_profile.id) >=
    //       teaching_profile.total_hours
    //   )
    //     this.patchTeachingProfile(teaching_profile);
    //   else if (teaching_profile.total_hours && teaching_profile.total_hours < 0)
    //     teaching_profile.total_hours = 0;
    // },
    // patchTeachingProfile(teaching_profile) {
    //   if (this.timeout) clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     this.saveTeachingProfile(teaching_profile);
    //   }, 1000);
    // },
    // clearProfessionalTitle(teaching_profile) {
    //   teaching_profile.professional_title = "";
    //   this.updateTeachingProfile(teaching_profile);
    // },
    // clearAcademicDegree(teaching_profile) {
    //   teaching_profile.academic_degree = "";
    //   this.updateTeachingProfile(teaching_profile);
    // },
    // clearSpecialization(teaching_profile) {
    //   teaching_profile.specialization = "";
    //   this.updateTeachingProfile(teaching_profile);
    // },
    // clearRequiredSkills(teaching_profile) {
    //   teaching_profile.required_skills = "";
    //   this.updateTeachingProfile(teaching_profile);
    // },
    // clearWorkExperienceValidity(teaching_profile) {
    //   teaching_profile.work_experience_validity = "";
    //   this.updateTeachingProfile(teaching_profile);
    // },
    // updateProfessionalTitle(teaching_profile, text) {
    //   teaching_profile.professional_title = text;
    //   this.saveTeachingProfile(teaching_profile);
    // },
    // updateAcademicDegree(teaching_profile, text) {
    //   teaching_profile.academic_degree = text;
    //   this.saveTeachingProfile(teaching_profile);
    // },
    // updateSpecialization(teaching_profile, text) {
    //   teaching_profile.specialization = text;
    //   this.saveTeachingProfile(teaching_profile);
    // },
    // updateRequiredSkills(teaching_profile, text) {
    //   teaching_profile.required_skills = text;
    //   this.saveTeachingProfile(teaching_profile);
    // },
    // updateWorkExperienceValidity(teaching_profile, text) {
    //   teaching_profile.work_experience_validity = text;
    //   this.saveTeachingProfile(teaching_profile);
    // },
    // saveTeachingProfile(teaching_profile) {
    //   if (teaching_profile.id == -1)
    //     this.createTeachingProfile(teaching_profile);
    //   else this.updateTeachingProfile(teaching_profile);
    // },
    createTeachingProfile(teaching_profile) {
      if (this.oldMatter && this.oldMatter.id) {
        teaching_profile.matter = this.oldMatter.id;
        this.$restful
          .Post(`/teaching/teaching-profile/`, teaching_profile)
          .then((response) => {
            this.teaching_profiles.push(response);
            this.$emit("change_teaching_profile");
            toast(
              this.$t("matterProgram.matterProgramView.teachingProfileCreated")
            );
          });
      }
    },
    mutateTeachingProfile(response) {
      const index = this.teaching_profiles.findIndex(
        (x) => x.id == response.id
      );
      if (index != -1) {
        this.teaching_profiles[index].professional_title =
          response.professional_title;
        this.teaching_profiles[index].academic_degree =
          response.academic_degree;
        this.teaching_profiles[index].specialization = response.specialization;
        this.teaching_profiles[index].required_skills =
          response.required_skills;
        this.teaching_profiles[index].experience_years =
          response.experience_years;
        this.teaching_profiles[index].work_experience_validity =
          response.work_experience_validity;
        this.teaching_profiles[index].total_hours = response.total_hours;
        this.teaching_profiles[index].total_theory_hours =
          response.total_theory_hours;
        this.teaching_profiles[index].total_practical_hours =
          response.total_practical_hours;
        this.teaching_profiles[index].total_hours_not_attended =
          response.total_hours_not_attended;
        this.teaching_profiles[index].creation_date = response.creation_date;
        this.teaching_profiles[index].update_date = response.update_date;
        this.teaching_profiles[index].created_by = response.created_by;
        this.teaching_profiles[index].updated_by = response.updated_by;
      }
    },
    updateTeachingProfile(teaching_profile) {
      this.$restful
        .Put(
          `/teaching/teaching-profile/${teaching_profile.id}/`,
          teaching_profile
        )
        .then((response) => {
          if (response) {
            this.$emit("change_teaching_profile");
            this.mutateTeachingProfile(response);
            toast(
              this.$t("matterProgram.matterProgramView.teachingProfileUpdated")
            );
          }
        });
    },
  },
  created() {
    this.fetchTeachingProfile();
  },
};
</script>

<style scoped>
table {
  width: 100%;
  table-layout: auto;
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 0px 0px;
}
table th {
  vertical-align: middle;
  border: 1px solid var(--kl-table-border) !important;
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.th-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
}
table td input[type="text"] {
  vertical-align: middle;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  width: 100%;
  min-height: 100%;
}
.wrapper2 {
  text-align: justify;
  margin: 10px;
}
.input-number-hour {
  max-width: 90px;
  height: 23px;
}
.input-number-year {
  max-width: 60px;
  height: 23px;
}
@media print {
  table {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>